// extracted by mini-css-extract-plugin
export var container = "_d6-0";
export var popoverContent = "_d6-1";
export var tosLink = "_d6-2";